import React, { useState } from "react";

import { SwitchContainer } from "./style";

export const ButtonSwitch = ({ id, sitiation, onClick }) => {
	const [checked, setChecked] = useState(sitiation);

	const customOnChange = () => {
		if (onClick) {
			onClick(id);
		}
	};

	return (
		<SwitchContainer>
			{/* <span>Ressarcindo</span> */}
			<label className='switch'>
				<input
					className='switch-input'
					type='checkbox'
					checked={checked ? "" : "checked"}
					disabled={checked ? "disabled" : ""}
					onChange={(e) => setChecked(!checked)}
					onClick={customOnChange}
				/>
				<div
					className='switch-label'
					data-smoke='sim'
					data-nosmoke='não'></div>
				<div className='slider'></div>
			</label>
		</SwitchContainer>
	);
};

export default ButtonSwitch;
